export const analyticsConfig = {
    LOCAL: 'G-FHXT716YZ3',
    DEV: 'G-PL2S37QKXR',
    PROD: 'G-LRMDFSKZLV',
};
